import { useRouter } from 'next/router';

const useRedirectFromReadPage = () => {
  const router = useRouter();
  const pageUrl = router?.asPath;
  const splitedBookPage = pageUrl.split('read')[0];
  typeof window !== 'undefined' && router.push(splitedBookPage);
};

export default useRedirectFromReadPage;
